import { post, get ,postChange} from './index'


export const list = params => {
  return get('/api/rule/list', params)
}

export const search = params => {
  return post('/api/rule/list', params)
}

export const tree = params => {
  return get('/api/rule/rule_tree', params)
}

export const treeAuth = params => {
  return get('/api/rule/auth_rule_tree', params)
}

export const add = params => {
  return post('/api/rule/add', params)
}
export const edit = params => {
  return post('/api/rule/edit', params)
}
export const del = params => {
  return post('/api/rule/del', params)
}
export const switchStatus = params => {
  return postChange('/api/rule/status_switch?id='+params.id, params, 'post')
}
export const getOptsList = params => {
  return get('/api/rule/get_button_list')
}


